<micro-lookup domain="domain" obj="environments" url="/domain/environments" [key]="environmentId" [link]="link"></micro-lookup>
